import superiorDoubleRoomImg from '../../assets/imgs/accommodations/superior_double.jpg';
import { CapitalizeFirstLetter } from '../../utils/capitalizeFirstLetter';
import { useEffect } from 'react';
import {
  BOOK_NOW_LINK,
  PROPERTY_NAME,
  separatorColoredDown,
  separatorColoredUp,
  SUPERIOR_DOUBLE_ROOM,
} from '../../utils/constants';
import Variables from '../../style/variables.scss';
import Gallery from '../home/gallery/Gallery';

const images = require.context('../../assets/imgs/superiorDoubleRoom', true);
const imageList = images?.keys().map((image: any) => images(image));

const SuperiorDouble = () => {
  useEffect(() => {
    document.title = `${CapitalizeFirstLetter(
      PROPERTY_NAME
    )} - ${CapitalizeFirstLetter(SUPERIOR_DOUBLE_ROOM)}`;
  }, []);

  return (
    <div id={SUPERIOR_DOUBLE_ROOM} className='accommodation'>
      <div className='accommodation_hero'>
        <img src={superiorDoubleRoomImg} alt={`superiror double room hero`} />
        <div className='accommodation_hero_title'>
          <h1>SUPERIOR DOUBLE</h1>
        </div>
      </div>
      {separatorColoredUp(Variables.aux)}
      <div className='accommodation_container container'>
        <div className='accommodation_container_info'>
          <div className='accommodation_container_info_text'>
            <p data-aos='fade-up'>
              All rooms are equipped with air conditioning and Wi-Fi Internet
              connection, flat screen satellite TV, phone line, shower,
              wardrobe, cabinet. All guests have complimentary water in the
              room.
            </p>
            <p data-aos='fade-up' data-aos-delay='50'>
              Some rooms feature a beautiful view on Peristyle square and
              Cathedral of St. Domnius and some of them feature original Palace
              walls.
            </p>
            <div
              className='accommodation_container_info_text_button'
              data-aos='fade-up'
              data-aos-delay='100'
            >
              <a
                href={BOOK_NOW_LINK}
                target='_blank'
                rel='noreferrer'
                className='opacity_transition_low'
              >
                <div>BOOK NOW</div>
              </a>
            </div>
          </div>
          <div className='accommodation_container_info_details'>
            <div data-aos='fade-up'>
              <p>ROOM FEATURES</p>
              <ul>
                <li>Double bed</li>
                <li>Two night stands</li>
                <li>Writing desk</li>
                <li>Chair</li>
                <li>Closet</li>
                <li>Wardrobe</li>
                <li>Air condition</li>
              </ul>
            </div>

            <div data-aos='fade-up' data-aos-delay='50'>
              <p>BATHROOM</p>
              <ul>
                <li>Shower</li>
                <li>Hairdryer</li>
                <li>Free toiletries</li>
                <li>Towels</li>
                <li>Linen</li>
              </ul>
            </div>

            <div data-aos='fade-up' data-aos-delay='100'>
              <p>ENTERTAINMENT</p>
              <ul>
                <li>Armchair and coffee table</li>
                <li>Flat screen satellite TV</li>
                <li>Wi-Fi Internet</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {separatorColoredDown(Variables.complementaryColor)}
      <Gallery imageList={imageList} />
    </div>
  );
};

export default SuperiorDouble;
